<template>
    <!-- 商家入驻弹窗 -->
    <el-dialog title="商家入驻申请" :visible.sync="visible" width="28.5%" center class="dialog-wrapper" :before-close="handleClose">

        <div class="flex justify-center info"><span>请填写商家基本信息，我们会在5个工作日内联系您</span></div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="商家名称" prop="shopName">
                <el-input v-model="ruleForm.shopName"></el-input>
            </el-form-item>
            <el-form-item label="商品名称" prop="goodsName">
                <el-input v-model="ruleForm.goodsName"></el-input>
            </el-form-item>
            <el-form-item label="商品品类" prop="goodsType">
                <el-input v-model="ruleForm.goodsType"></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="name">
                <el-input v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone">
                <el-input v-model="ruleForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
                <el-input v-model="ruleForm.email"></el-input>
            </el-form-item>
        </el-form>
        <el-row class="button-wrapper">
            <el-button class="btn" :class="isActive ? 'active' : ''" type="warning" @click="submitForm('ruleForm')">申请入驻</el-button>
        </el-row>
    </el-dialog>
</template>

<script>
export default {
    name: 'store-in',
    props: {
        visibleDialog: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            ruleForm: {
                shopName: '',
                goodsName: '',
                goodsType: '',
                name: '',
                phone: '',
                email: '',
            },
            rules: {
                shopName: [
                    { required: true, message: ' ', trigger: 'blur' },
                ],
                goodsName: [
                    { required: true, message: ' ', trigger: 'blur' },
                ],
                goodsType: [
                    { required: true, message: ' ', trigger: 'blur' },
                ],
                name: [
                    { required: true, message: ' ', trigger: 'blur' },
                ],
                phone: [
                    { required: true, message: ' ', trigger: 'blur' },
                ],
                email: [
                    { required: true, message: ' ', trigger: 'blur' },
                ],
            }
        }
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$message.success('提交成功，我们会在5个工作日内联系您')
                    this.handleClose()
                } else {
                    this.$message.warning('请完整填写您的入驻信息')
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        handleClose() {
            this.visible = false
            // this.visibleDialog = false
            this.$emit('update:visibleDialog',false)
        }
    },
    watch: {
        visibleDialog: {
            handler(newVal) {
                this.visible = newVal
            },
            immediate: true
        }
    },
    computed: {
        isActive() {
            console.log(this.ruleForm, '应该要走这里吧');
            console.log(Object.values(this.ruleForm), '数组');
            console.log(Object.values(this.ruleForm).every(item => item), '结果');
            return Object.values(this.ruleForm).every(item => item)
        }
    }
}
</script>

<style lang="less" scoped>
.flex {
    display: flex;
}

.justify-center {
    justify-content: center;
}

.pointer {
    cursor: pointer;
}

.header {
    display: flex;
    align-items: center;
    height: 60px;
    box-shadow: 0px 0px 6px 0px rgba(37, 68, 118, 0.16);

    .logo-wrapper {
        .logo {
            width: 128px;
            height: 26px;
        }
    }

    .right-wrapper {
        position: absolute;
        min-width: 340px;
        right: 0;
        align-items: center;

        .gray-text {
            font-size: 14px;
            font-weight: 500;
            letter-spacing: 0px;
            line-height: 20px;
            color: rgba(124, 124, 124, 1);
            text-align: left;
            vertical-align: top;
        }

        .line {
            width: 0px;
            height: 12px;
            border: 1px solid rgba(224, 224, 224, 1);
            margin-left: 9px;
            margin-right: 9px;
        }

        .icon {
            width: 19px;
            height: 17px;
            margin-right: 5px;
        }

        .login {
            min-width: 90px;
            height: 28px;
            border-radius: 10px;
            border: 1px solid rgba(224, 224, 224, 1);
            align-items: center;
            box-sizing: border-box;
            padding-left: 10px;
            padding-right: 10px;
        }
    }
}

:deep(.dialog-wrapper) {
    .info {
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 21px;
        color: rgba(96, 90, 90, 1);
        text-align: left;
        vertical-align: top;
        margin-bottom: 16px;
    }

    .el-dialog__body {
        padding: 0;
        margin-top: 7px;
    }

    .el-dialog__header {
        height: 76px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;

        span {
            font-size: 18px;
            font-weight: 500;
            letter-spacing: 0.36px;
            line-height: 25px;
            color: rgba(59, 57, 72, 1);
            text-align: left;
            vertical-align: top;
        }

        button {
            display: none;
        }
    }

    .el-form {
        padding-left: 44px;
        padding-right: 44px;
        box-sizing: border-box;
    }

    .el-form-item__content {
        display: flex;
    }

    .el-form-item__label:after {
        content: '*';
        color: #F56C6C;
        margin-right: 4px;
    }

    .el-form-item__label:before {
        content: '' !important;
    }

    input {
        width: 240px;
        height: 36px;
        border-radius: 8px;
        background: rgba(247, 247, 247, 1)
    }

    .button-wrapper {
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn {
            width: 114px;
            height: 36px;
            border-radius: 8px;
            background: rgba(244, 185, 184, 1);
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgba(255, 255, 255, 1);
            line-height: 21px;
        }
    }
}
.active {
    background: #C13A36!important;
}
</style>